import { useState, useEffect } from "react";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  doc,
  updateDoc,
} from "firebase/firestore";

import { useNavigate } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";
import { MdNewReleases } from "react-icons/md";

import { useTranslation } from "react-i18next";

function NotificationsPage() {
  const { t } = useTranslation("common");

  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const [notifications, setNotifications] = useState();
  const [unreadNotifications, setUnreadNotifications] = useState();
  const fetchNotifications = async () => {
    try {
      setIsLoading(true);

      let fetchedNotifications = [];
      // eslint-disable-next-line
      let fetchedUnreadNotifications = 0;
      const seenKeys = new Set();

      const q = query(
        collection(db, "notifications"),
        where("recipientUid", "==", user?.uid),
      );
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newNotification = doc.data();
        // Deduplicate by content to prevent showing duplicate notifications
        const key = `${newNotification.title}|${newNotification.description}`;
        if (!seenKeys.has(key)) {
          seenKeys.add(key);
          fetchedNotifications.push(newNotification);
          if (!newNotification.isRead) {
            fetchedUnreadNotifications += 1;
          }
        }
      });

      // Sort notifications by dateCreated in descending order (newest first)
      fetchedNotifications.sort(
        (a, b) => new Date(b.dateCreated) - new Date(a.dateCreated),
      );

      setNotifications(fetchedNotifications);

      setUnreadNotifications(fetchedUnreadNotifications);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching notifications");
    }
  };

  useEffect(() => {
    if (user) {
      fetchNotifications();
    }
    // eslint-disable-next-line
  }, [user]);

  const markNotificationAsRead = async (notification) => {
    try {
      setIsLoading(true);

      const q = query(
        collection(db, "notifications"),
        where("uid", "==", notification.uid),
      );
      const findNotifications = await getDocs(q);
      findNotifications.forEach(async (notificationObject) => {
        const getNotification = doc(db, "notifications", notificationObject.id);
        await updateDoc(getNotification, {
          isRead: true,
        });
      });

      fetchNotifications();

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while updating notification");
    }
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="notificationsPage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        {t("notifications").toUpperCase()}
        <span>{unreadNotifications ? unreadNotifications : 0}</span>
      </h1>
      <div>
        {notifications?.map((notification) => {
          return (
            <div
              onClick={() => markNotificationAsRead(notification)}
              className="notificationsPageNotificationContainer"
              style={{ cursor: notification.isRead ? "default" : "pointer" }}
            >
              <p className="notificationTitle">{notification.title}</p>
              <p className="notificationDescription">
                {notification.description}
              </p>
              <p className="notificationDate">
                {new Date(notification.dateCreated).toLocaleDateString("de-DE")}{" "}
                {new Date(notification.dateCreated).toLocaleTimeString(
                  "en-US",
                  {
                    hour: "numeric",
                    minute: "2-digit",
                    hour12: true,
                  },
                )}
              </p>
              {!notification.isRead ? <MdNewReleases /> : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default NotificationsPage;
